import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { App } from "./app/app";
import { registerLocaleData } from "@angular/common";
import localeEsMx from "@angular/common/locales/es-MX";

registerLocaleData(localeEsMx, "es-MX");

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
